import { Welcome } from '@/containers/welcome';

export default function WelcomeRoute() {
  return <Welcome />;
}
